// source: receptorutil/receptorutil.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var attachment_attachment_pb = require('../attachment/attachment_pb.js');
goog.object.extend(proto, attachment_attachment_pb);
goog.exportSymbol('proto.receptorutil.AddDirectoryScanSettingRequest', null, global);
goog.exportSymbol('proto.receptorutil.AddDirectoryScanSettingResponse', null, global);
goog.exportSymbol('proto.receptorutil.CheckReceptorFileAccessRequest', null, global);
goog.exportSymbol('proto.receptorutil.CheckReceptorFileAccessResponse', null, global);
goog.exportSymbol('proto.receptorutil.CreateWorkflowTicketRequest', null, global);
goog.exportSymbol('proto.receptorutil.CreateWorkflowTicketResponse', null, global);
goog.exportSymbol('proto.receptorutil.DeleteDirectoryScanSettingRequest', null, global);
goog.exportSymbol('proto.receptorutil.DeleteDirectoryScanSettingResponse', null, global);
goog.exportSymbol('proto.receptorutil.DirectoryNode', null, global);
goog.exportSymbol('proto.receptorutil.DirectoryScanFile', null, global);
goog.exportSymbol('proto.receptorutil.DirectoryScanNode', null, global);
goog.exportSymbol('proto.receptorutil.DirectoryScanSettingSummary', null, global);
goog.exportSymbol('proto.receptorutil.FindWorkflowTicketByTitleRequest', null, global);
goog.exportSymbol('proto.receptorutil.FindWorkflowTicketByTitleResponse', null, global);
goog.exportSymbol('proto.receptorutil.GetDirectoryScanRequest', null, global);
goog.exportSymbol('proto.receptorutil.GetDirectoryScanResponse', null, global);
goog.exportSymbol('proto.receptorutil.GetDirectoryScanSettingEvidencesRequest', null, global);
goog.exportSymbol('proto.receptorutil.GetDirectoryScanSettingEvidencesResponse', null, global);
goog.exportSymbol('proto.receptorutil.GetDirectoryScanSettingRequest', null, global);
goog.exportSymbol('proto.receptorutil.GetDirectoryScanSettingResponse', null, global);
goog.exportSymbol('proto.receptorutil.GetGoogleDrivePickerConfigRequest', null, global);
goog.exportSymbol('proto.receptorutil.GetGoogleDrivePickerConfigResponse', null, global);
goog.exportSymbol('proto.receptorutil.GetReceptorMetadataRequest', null, global);
goog.exportSymbol('proto.receptorutil.GetReceptorMetadataResponse', null, global);
goog.exportSymbol('proto.receptorutil.GetWorkflowTicketStatusRequest', null, global);
goog.exportSymbol('proto.receptorutil.GetWorkflowTicketStatusResponse', null, global);
goog.exportSymbol('proto.receptorutil.GetWorkflowUsersRequest', null, global);
goog.exportSymbol('proto.receptorutil.GetWorkflowUsersResponse', null, global);
goog.exportSymbol('proto.receptorutil.Label', null, global);
goog.exportSymbol('proto.receptorutil.ListDirectoryScanSettingsRequest', null, global);
goog.exportSymbol('proto.receptorutil.ListDirectoryScanSettingsResponse', null, global);
goog.exportSymbol('proto.receptorutil.MetadataType', null, global);
goog.exportSymbol('proto.receptorutil.ReceptorFileAccess', null, global);
goog.exportSymbol('proto.receptorutil.UpdateDirectoryScanSettingRequest', null, global);
goog.exportSymbol('proto.receptorutil.UpdateDirectoryScanSettingResponse', null, global);
goog.exportSymbol('proto.receptorutil.WorkflowTicket', null, global);
goog.exportSymbol('proto.receptorutil.WorkflowUser', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetReceptorMetadataRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.GetReceptorMetadataRequest.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.GetReceptorMetadataRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetReceptorMetadataRequest.displayName = 'proto.receptorutil.GetReceptorMetadataRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.DirectoryNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.DirectoryNode.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.DirectoryNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.DirectoryNode.displayName = 'proto.receptorutil.DirectoryNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.Label = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.Label, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.Label.displayName = 'proto.receptorutil.Label';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetReceptorMetadataResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.GetReceptorMetadataResponse.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.GetReceptorMetadataResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetReceptorMetadataResponse.displayName = 'proto.receptorutil.GetReceptorMetadataResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetDirectoryScanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.GetDirectoryScanRequest.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.GetDirectoryScanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetDirectoryScanRequest.displayName = 'proto.receptorutil.GetDirectoryScanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.DirectoryScanFile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.DirectoryScanFile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.DirectoryScanFile.displayName = 'proto.receptorutil.DirectoryScanFile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.DirectoryScanNode = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.DirectoryScanNode.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.DirectoryScanNode, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.DirectoryScanNode.displayName = 'proto.receptorutil.DirectoryScanNode';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetDirectoryScanResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.GetDirectoryScanResponse.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.GetDirectoryScanResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetDirectoryScanResponse.displayName = 'proto.receptorutil.GetDirectoryScanResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.ListDirectoryScanSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.ListDirectoryScanSettingsRequest.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.ListDirectoryScanSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.ListDirectoryScanSettingsRequest.displayName = 'proto.receptorutil.ListDirectoryScanSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.DirectoryScanSettingSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.DirectoryScanSettingSummary.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.DirectoryScanSettingSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.DirectoryScanSettingSummary.displayName = 'proto.receptorutil.DirectoryScanSettingSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.ListDirectoryScanSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.ListDirectoryScanSettingsResponse.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.ListDirectoryScanSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.ListDirectoryScanSettingsResponse.displayName = 'proto.receptorutil.ListDirectoryScanSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetDirectoryScanSettingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.GetDirectoryScanSettingRequest.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.GetDirectoryScanSettingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetDirectoryScanSettingRequest.displayName = 'proto.receptorutil.GetDirectoryScanSettingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetDirectoryScanSettingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.GetDirectoryScanSettingResponse.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.GetDirectoryScanSettingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetDirectoryScanSettingResponse.displayName = 'proto.receptorutil.GetDirectoryScanSettingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.AddDirectoryScanSettingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.AddDirectoryScanSettingRequest.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.AddDirectoryScanSettingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.AddDirectoryScanSettingRequest.displayName = 'proto.receptorutil.AddDirectoryScanSettingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.AddDirectoryScanSettingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.AddDirectoryScanSettingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.AddDirectoryScanSettingResponse.displayName = 'proto.receptorutil.AddDirectoryScanSettingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.UpdateDirectoryScanSettingRequest.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.UpdateDirectoryScanSettingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.UpdateDirectoryScanSettingRequest.displayName = 'proto.receptorutil.UpdateDirectoryScanSettingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.UpdateDirectoryScanSettingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.UpdateDirectoryScanSettingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.UpdateDirectoryScanSettingResponse.displayName = 'proto.receptorutil.UpdateDirectoryScanSettingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.DeleteDirectoryScanSettingRequest.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.DeleteDirectoryScanSettingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.DeleteDirectoryScanSettingRequest.displayName = 'proto.receptorutil.DeleteDirectoryScanSettingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.DeleteDirectoryScanSettingResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.DeleteDirectoryScanSettingResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.DeleteDirectoryScanSettingResponse.displayName = 'proto.receptorutil.DeleteDirectoryScanSettingResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.GetDirectoryScanSettingEvidencesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.displayName = 'proto.receptorutil.GetDirectoryScanSettingEvidencesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.GetDirectoryScanSettingEvidencesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.displayName = 'proto.receptorutil.GetDirectoryScanSettingEvidencesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.WorkflowTicket = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.WorkflowTicket, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.WorkflowTicket.displayName = 'proto.receptorutil.WorkflowTicket';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.FindWorkflowTicketByTitleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.FindWorkflowTicketByTitleRequest.displayName = 'proto.receptorutil.FindWorkflowTicketByTitleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.FindWorkflowTicketByTitleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.FindWorkflowTicketByTitleResponse.displayName = 'proto.receptorutil.FindWorkflowTicketByTitleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetWorkflowTicketStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.GetWorkflowTicketStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetWorkflowTicketStatusRequest.displayName = 'proto.receptorutil.GetWorkflowTicketStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetWorkflowTicketStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.GetWorkflowTicketStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetWorkflowTicketStatusResponse.displayName = 'proto.receptorutil.GetWorkflowTicketStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.WorkflowUser = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.WorkflowUser, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.WorkflowUser.displayName = 'proto.receptorutil.WorkflowUser';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetWorkflowUsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.GetWorkflowUsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetWorkflowUsersRequest.displayName = 'proto.receptorutil.GetWorkflowUsersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetWorkflowUsersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.GetWorkflowUsersResponse.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.GetWorkflowUsersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetWorkflowUsersResponse.displayName = 'proto.receptorutil.GetWorkflowUsersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.CreateWorkflowTicketRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.CreateWorkflowTicketRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.CreateWorkflowTicketRequest.displayName = 'proto.receptorutil.CreateWorkflowTicketRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.CreateWorkflowTicketResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.CreateWorkflowTicketResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.CreateWorkflowTicketResponse.displayName = 'proto.receptorutil.CreateWorkflowTicketResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.CheckReceptorFileAccessRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.CheckReceptorFileAccessRequest.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.CheckReceptorFileAccessRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.CheckReceptorFileAccessRequest.displayName = 'proto.receptorutil.CheckReceptorFileAccessRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.ReceptorFileAccess = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.ReceptorFileAccess, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.ReceptorFileAccess.displayName = 'proto.receptorutil.ReceptorFileAccess';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.CheckReceptorFileAccessResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.receptorutil.CheckReceptorFileAccessResponse.repeatedFields_, null);
};
goog.inherits(proto.receptorutil.CheckReceptorFileAccessResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.CheckReceptorFileAccessResponse.displayName = 'proto.receptorutil.CheckReceptorFileAccessResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetGoogleDrivePickerConfigRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.GetGoogleDrivePickerConfigRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetGoogleDrivePickerConfigRequest.displayName = 'proto.receptorutil.GetGoogleDrivePickerConfigRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.receptorutil.GetGoogleDrivePickerConfigResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.receptorutil.GetGoogleDrivePickerConfigResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.receptorutil.GetGoogleDrivePickerConfigResponse.displayName = 'proto.receptorutil.GetGoogleDrivePickerConfigResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.GetReceptorMetadataRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetReceptorMetadataRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetReceptorMetadataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetReceptorMetadataRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    metadataTypesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    isRoot: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    parentId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetReceptorMetadataRequest}
 */
proto.receptorutil.GetReceptorMetadataRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetReceptorMetadataRequest;
  return proto.receptorutil.GetReceptorMetadataRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetReceptorMetadataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetReceptorMetadataRequest}
 */
proto.receptorutil.GetReceptorMetadataRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceptorId(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.receptorutil.MetadataType>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addMetadataTypes(values[i]);
      }
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRoot(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetReceptorMetadataRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetReceptorMetadataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetReceptorMetadataRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getMetadataTypesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getIsRoot();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getParentId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * repeated string receptor_id = 1;
 * @return {!Array<string>}
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.getReceptorIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.receptorutil.GetReceptorMetadataRequest} returns this
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.setReceptorIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.GetReceptorMetadataRequest} returns this
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.addReceptorId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetReceptorMetadataRequest} returns this
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.clearReceptorIdList = function() {
  return this.setReceptorIdList([]);
};


/**
 * repeated MetadataType metadata_types = 2;
 * @return {!Array<!proto.receptorutil.MetadataType>}
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.getMetadataTypesList = function() {
  return /** @type {!Array<!proto.receptorutil.MetadataType>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.receptorutil.MetadataType>} value
 * @return {!proto.receptorutil.GetReceptorMetadataRequest} returns this
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.setMetadataTypesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.receptorutil.MetadataType} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.GetReceptorMetadataRequest} returns this
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.addMetadataTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetReceptorMetadataRequest} returns this
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.clearMetadataTypesList = function() {
  return this.setMetadataTypesList([]);
};


/**
 * optional bool is_root = 3;
 * @return {boolean}
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.getIsRoot = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.GetReceptorMetadataRequest} returns this
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.setIsRoot = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string parent_id = 4;
 * @return {string}
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.getParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetReceptorMetadataRequest} returns this
 */
proto.receptorutil.GetReceptorMetadataRequest.prototype.setParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.DirectoryNode.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.DirectoryNode.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.DirectoryNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.DirectoryNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DirectoryNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, ""),
    spaceId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    url: jspb.Message.getFieldWithDefault(msg, 5, ""),
    relevantDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
    fileName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    childrenList: jspb.Message.toObjectList(msg.getChildrenList(),
    proto.receptorutil.DirectoryNode.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.DirectoryNode}
 */
proto.receptorutil.DirectoryNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.DirectoryNode;
  return proto.receptorutil.DirectoryNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.DirectoryNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.DirectoryNode}
 */
proto.receptorutil.DirectoryNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSpaceId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRelevantDate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 8:
      var value = new proto.receptorutil.DirectoryNode;
      reader.readMessage(value,proto.receptorutil.DirectoryNode.deserializeBinaryFromReader);
      msg.addChildren(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.DirectoryNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.DirectoryNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.DirectoryNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DirectoryNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSpaceId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRelevantDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getChildrenList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.receptorutil.DirectoryNode.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.receptorutil.DirectoryNode.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryNode} returns this
 */
proto.receptorutil.DirectoryNode.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.receptorutil.DirectoryNode.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryNode} returns this
 */
proto.receptorutil.DirectoryNode.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.receptorutil.DirectoryNode.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryNode} returns this
 */
proto.receptorutil.DirectoryNode.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string space_id = 4;
 * @return {string}
 */
proto.receptorutil.DirectoryNode.prototype.getSpaceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryNode} returns this
 */
proto.receptorutil.DirectoryNode.prototype.setSpaceId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.receptorutil.DirectoryNode.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryNode} returns this
 */
proto.receptorutil.DirectoryNode.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string relevant_date = 6;
 * @return {string}
 */
proto.receptorutil.DirectoryNode.prototype.getRelevantDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryNode} returns this
 */
proto.receptorutil.DirectoryNode.prototype.setRelevantDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string file_name = 7;
 * @return {string}
 */
proto.receptorutil.DirectoryNode.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryNode} returns this
 */
proto.receptorutil.DirectoryNode.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated DirectoryNode children = 8;
 * @return {!Array<!proto.receptorutil.DirectoryNode>}
 */
proto.receptorutil.DirectoryNode.prototype.getChildrenList = function() {
  return /** @type{!Array<!proto.receptorutil.DirectoryNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.DirectoryNode, 8));
};


/**
 * @param {!Array<!proto.receptorutil.DirectoryNode>} value
 * @return {!proto.receptorutil.DirectoryNode} returns this
*/
proto.receptorutil.DirectoryNode.prototype.setChildrenList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.receptorutil.DirectoryNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.DirectoryNode}
 */
proto.receptorutil.DirectoryNode.prototype.addChildren = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.receptorutil.DirectoryNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.DirectoryNode} returns this
 */
proto.receptorutil.DirectoryNode.prototype.clearChildrenList = function() {
  return this.setChildrenList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.Label.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.Label.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.Label} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.Label.toObject = function(includeInstance, msg) {
  var f, obj = {
    scopeId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    id: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.Label}
 */
proto.receptorutil.Label.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.Label;
  return proto.receptorutil.Label.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.Label} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.Label}
 */
proto.receptorutil.Label.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScopeId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.Label.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.Label.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.Label} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.Label.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScopeId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string scope_id = 1;
 * @return {string}
 */
proto.receptorutil.Label.prototype.getScopeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.Label} returns this
 */
proto.receptorutil.Label.prototype.setScopeId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string id = 2;
 * @return {string}
 */
proto.receptorutil.Label.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.Label} returns this
 */
proto.receptorutil.Label.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.receptorutil.Label.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.Label} returns this
 */
proto.receptorutil.Label.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.GetReceptorMetadataResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetReceptorMetadataResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetReceptorMetadataResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetReceptorMetadataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetReceptorMetadataResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    directoryTreeList: jspb.Message.toObjectList(msg.getDirectoryTreeList(),
    proto.receptorutil.DirectoryNode.toObject, includeInstance),
    labelsList: jspb.Message.toObjectList(msg.getLabelsList(),
    proto.receptorutil.Label.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetReceptorMetadataResponse}
 */
proto.receptorutil.GetReceptorMetadataResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetReceptorMetadataResponse;
  return proto.receptorutil.GetReceptorMetadataResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetReceptorMetadataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetReceptorMetadataResponse}
 */
proto.receptorutil.GetReceptorMetadataResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.receptorutil.DirectoryNode;
      reader.readMessage(value,proto.receptorutil.DirectoryNode.deserializeBinaryFromReader);
      msg.addDirectoryTree(value);
      break;
    case 2:
      var value = new proto.receptorutil.Label;
      reader.readMessage(value,proto.receptorutil.Label.deserializeBinaryFromReader);
      msg.addLabels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetReceptorMetadataResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetReceptorMetadataResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetReceptorMetadataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetReceptorMetadataResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDirectoryTreeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.receptorutil.DirectoryNode.serializeBinaryToWriter
    );
  }
  f = message.getLabelsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.receptorutil.Label.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DirectoryNode directory_tree = 1;
 * @return {!Array<!proto.receptorutil.DirectoryNode>}
 */
proto.receptorutil.GetReceptorMetadataResponse.prototype.getDirectoryTreeList = function() {
  return /** @type{!Array<!proto.receptorutil.DirectoryNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.DirectoryNode, 1));
};


/**
 * @param {!Array<!proto.receptorutil.DirectoryNode>} value
 * @return {!proto.receptorutil.GetReceptorMetadataResponse} returns this
*/
proto.receptorutil.GetReceptorMetadataResponse.prototype.setDirectoryTreeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.receptorutil.DirectoryNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.DirectoryNode}
 */
proto.receptorutil.GetReceptorMetadataResponse.prototype.addDirectoryTree = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.receptorutil.DirectoryNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetReceptorMetadataResponse} returns this
 */
proto.receptorutil.GetReceptorMetadataResponse.prototype.clearDirectoryTreeList = function() {
  return this.setDirectoryTreeList([]);
};


/**
 * repeated Label labels = 2;
 * @return {!Array<!proto.receptorutil.Label>}
 */
proto.receptorutil.GetReceptorMetadataResponse.prototype.getLabelsList = function() {
  return /** @type{!Array<!proto.receptorutil.Label>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.Label, 2));
};


/**
 * @param {!Array<!proto.receptorutil.Label>} value
 * @return {!proto.receptorutil.GetReceptorMetadataResponse} returns this
*/
proto.receptorutil.GetReceptorMetadataResponse.prototype.setLabelsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.receptorutil.Label=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.Label}
 */
proto.receptorutil.GetReceptorMetadataResponse.prototype.addLabels = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.receptorutil.Label, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetReceptorMetadataResponse} returns this
 */
proto.receptorutil.GetReceptorMetadataResponse.prototype.clearLabelsList = function() {
  return this.setLabelsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.GetDirectoryScanRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetDirectoryScanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetDirectoryScanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    rootPath: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rootKey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    includeSubdirs: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    filePattern: jspb.Message.getFieldWithDefault(msg, 5, ""),
    parentKey: jspb.Message.getFieldWithDefault(msg, 6, ""),
    maxDepth: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetDirectoryScanRequest}
 */
proto.receptorutil.GetDirectoryScanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetDirectoryScanRequest;
  return proto.receptorutil.GetDirectoryScanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetDirectoryScanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetDirectoryScanRequest}
 */
proto.receptorutil.GetDirectoryScanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceptorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootPath(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootKey(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeSubdirs(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilePattern(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentKey(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxDepth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetDirectoryScanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetDirectoryScanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getRootPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRootKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIncludeSubdirs();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getFilePattern();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getParentKey();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMaxDepth();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
};


/**
 * repeated string receptor_id = 1;
 * @return {!Array<string>}
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.getReceptorIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.receptorutil.GetDirectoryScanRequest} returns this
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.setReceptorIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.GetDirectoryScanRequest} returns this
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.addReceptorId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetDirectoryScanRequest} returns this
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.clearReceptorIdList = function() {
  return this.setReceptorIdList([]);
};


/**
 * optional string root_path = 2;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.getRootPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanRequest} returns this
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.setRootPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string root_key = 3;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.getRootKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanRequest} returns this
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.setRootKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool include_subdirs = 4;
 * @return {boolean}
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.getIncludeSubdirs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.GetDirectoryScanRequest} returns this
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.setIncludeSubdirs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string file_pattern = 5;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.getFilePattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanRequest} returns this
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.setFilePattern = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string parent_key = 6;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.getParentKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanRequest} returns this
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.setParentKey = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint32 max_depth = 7;
 * @return {number}
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.getMaxDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.GetDirectoryScanRequest} returns this
 */
proto.receptorutil.GetDirectoryScanRequest.prototype.setMaxDepth = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.DirectoryScanFile.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.DirectoryScanFile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.DirectoryScanFile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DirectoryScanFile.toObject = function(includeInstance, msg) {
  var f, obj = {
    fileName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fileId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    lastModifiedAt: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mimeType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    importKey: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.DirectoryScanFile}
 */
proto.receptorutil.DirectoryScanFile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.DirectoryScanFile;
  return proto.receptorutil.DirectoryScanFile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.DirectoryScanFile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.DirectoryScanFile}
 */
proto.receptorutil.DirectoryScanFile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastModifiedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setImportKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.DirectoryScanFile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.DirectoryScanFile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.DirectoryScanFile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DirectoryScanFile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLastModifiedAt();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getImportKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string file_name = 1;
 * @return {string}
 */
proto.receptorutil.DirectoryScanFile.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanFile} returns this
 */
proto.receptorutil.DirectoryScanFile.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string file_id = 2;
 * @return {string}
 */
proto.receptorutil.DirectoryScanFile.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanFile} returns this
 */
proto.receptorutil.DirectoryScanFile.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string last_modified_at = 3;
 * @return {string}
 */
proto.receptorutil.DirectoryScanFile.prototype.getLastModifiedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanFile} returns this
 */
proto.receptorutil.DirectoryScanFile.prototype.setLastModifiedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mime_type = 4;
 * @return {string}
 */
proto.receptorutil.DirectoryScanFile.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanFile} returns this
 */
proto.receptorutil.DirectoryScanFile.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string import_key = 5;
 * @return {string}
 */
proto.receptorutil.DirectoryScanFile.prototype.getImportKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanFile} returns this
 */
proto.receptorutil.DirectoryScanFile.prototype.setImportKey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.DirectoryScanNode.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.DirectoryScanNode.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.DirectoryScanNode.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.DirectoryScanNode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DirectoryScanNode.toObject = function(includeInstance, msg) {
  var f, obj = {
    dirName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dirKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    include: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    importKey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    display: jspb.Message.getFieldWithDefault(msg, 11, ""),
    dirUrl: jspb.Message.getFieldWithDefault(msg, 10, ""),
    filesList: jspb.Message.toObjectList(msg.getFilesList(),
    proto.receptorutil.DirectoryScanFile.toObject, includeInstance),
    directoriesList: jspb.Message.toObjectList(msg.getDirectoriesList(),
    proto.receptorutil.DirectoryScanNode.toObject, includeInstance),
    fileCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    subDirectoryCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
    evidenceCount: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.DirectoryScanNode}
 */
proto.receptorutil.DirectoryScanNode.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.DirectoryScanNode;
  return proto.receptorutil.DirectoryScanNode.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.DirectoryScanNode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.DirectoryScanNode}
 */
proto.receptorutil.DirectoryScanNode.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDirName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDirKey(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInclude(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setImportKey(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplay(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDirUrl(value);
      break;
    case 5:
      var value = new proto.receptorutil.DirectoryScanFile;
      reader.readMessage(value,proto.receptorutil.DirectoryScanFile.deserializeBinaryFromReader);
      msg.addFiles(value);
      break;
    case 6:
      var value = new proto.receptorutil.DirectoryScanNode;
      reader.readMessage(value,proto.receptorutil.DirectoryScanNode.deserializeBinaryFromReader);
      msg.addDirectories(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFileCount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSubDirectoryCount(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEvidenceCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.DirectoryScanNode.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.DirectoryScanNode.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.DirectoryScanNode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DirectoryScanNode.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDirName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDirKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInclude();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getImportKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisplay();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDirUrl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.receptorutil.DirectoryScanFile.serializeBinaryToWriter
    );
  }
  f = message.getDirectoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.receptorutil.DirectoryScanNode.serializeBinaryToWriter
    );
  }
  f = message.getFileCount();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getSubDirectoryCount();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getEvidenceCount();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
};


/**
 * optional string dir_name = 1;
 * @return {string}
 */
proto.receptorutil.DirectoryScanNode.prototype.getDirName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
 */
proto.receptorutil.DirectoryScanNode.prototype.setDirName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string dir_key = 2;
 * @return {string}
 */
proto.receptorutil.DirectoryScanNode.prototype.getDirKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
 */
proto.receptorutil.DirectoryScanNode.prototype.setDirKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool include = 3;
 * @return {boolean}
 */
proto.receptorutil.DirectoryScanNode.prototype.getInclude = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
 */
proto.receptorutil.DirectoryScanNode.prototype.setInclude = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string import_key = 4;
 * @return {string}
 */
proto.receptorutil.DirectoryScanNode.prototype.getImportKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
 */
proto.receptorutil.DirectoryScanNode.prototype.setImportKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string display = 11;
 * @return {string}
 */
proto.receptorutil.DirectoryScanNode.prototype.getDisplay = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
 */
proto.receptorutil.DirectoryScanNode.prototype.setDisplay = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string dir_url = 10;
 * @return {string}
 */
proto.receptorutil.DirectoryScanNode.prototype.getDirUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
 */
proto.receptorutil.DirectoryScanNode.prototype.setDirUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated DirectoryScanFile files = 5;
 * @return {!Array<!proto.receptorutil.DirectoryScanFile>}
 */
proto.receptorutil.DirectoryScanNode.prototype.getFilesList = function() {
  return /** @type{!Array<!proto.receptorutil.DirectoryScanFile>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.DirectoryScanFile, 5));
};


/**
 * @param {!Array<!proto.receptorutil.DirectoryScanFile>} value
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
*/
proto.receptorutil.DirectoryScanNode.prototype.setFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.receptorutil.DirectoryScanFile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.DirectoryScanFile}
 */
proto.receptorutil.DirectoryScanNode.prototype.addFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.receptorutil.DirectoryScanFile, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
 */
proto.receptorutil.DirectoryScanNode.prototype.clearFilesList = function() {
  return this.setFilesList([]);
};


/**
 * repeated DirectoryScanNode directories = 6;
 * @return {!Array<!proto.receptorutil.DirectoryScanNode>}
 */
proto.receptorutil.DirectoryScanNode.prototype.getDirectoriesList = function() {
  return /** @type{!Array<!proto.receptorutil.DirectoryScanNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.DirectoryScanNode, 6));
};


/**
 * @param {!Array<!proto.receptorutil.DirectoryScanNode>} value
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
*/
proto.receptorutil.DirectoryScanNode.prototype.setDirectoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.receptorutil.DirectoryScanNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.DirectoryScanNode}
 */
proto.receptorutil.DirectoryScanNode.prototype.addDirectories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.receptorutil.DirectoryScanNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
 */
proto.receptorutil.DirectoryScanNode.prototype.clearDirectoriesList = function() {
  return this.setDirectoriesList([]);
};


/**
 * optional uint32 file_count = 7;
 * @return {number}
 */
proto.receptorutil.DirectoryScanNode.prototype.getFileCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
 */
proto.receptorutil.DirectoryScanNode.prototype.setFileCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint32 sub_directory_count = 8;
 * @return {number}
 */
proto.receptorutil.DirectoryScanNode.prototype.getSubDirectoryCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
 */
proto.receptorutil.DirectoryScanNode.prototype.setSubDirectoryCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional uint32 evidence_count = 9;
 * @return {number}
 */
proto.receptorutil.DirectoryScanNode.prototype.getEvidenceCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.DirectoryScanNode} returns this
 */
proto.receptorutil.DirectoryScanNode.prototype.setEvidenceCount = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.GetDirectoryScanResponse.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetDirectoryScanResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetDirectoryScanResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    rootPath: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rootKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    includeSubdirs: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    filePattern: jspb.Message.getFieldWithDefault(msg, 4, ""),
    directoriesList: jspb.Message.toObjectList(msg.getDirectoriesList(),
    proto.receptorutil.DirectoryScanNode.toObject, includeInstance),
    evidencesList: jspb.Message.toObjectList(msg.getEvidencesList(),
    attachment_attachment_pb.Evidence.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetDirectoryScanResponse}
 */
proto.receptorutil.GetDirectoryScanResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetDirectoryScanResponse;
  return proto.receptorutil.GetDirectoryScanResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetDirectoryScanResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetDirectoryScanResponse}
 */
proto.receptorutil.GetDirectoryScanResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootPath(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootKey(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeSubdirs(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilePattern(value);
      break;
    case 5:
      var value = new proto.receptorutil.DirectoryScanNode;
      reader.readMessage(value,proto.receptorutil.DirectoryScanNode.deserializeBinaryFromReader);
      msg.addDirectories(value);
      break;
    case 6:
      var value = new attachment_attachment_pb.Evidence;
      reader.readMessage(value,attachment_attachment_pb.Evidence.deserializeBinaryFromReader);
      msg.addEvidences(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetDirectoryScanResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetDirectoryScanResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRootPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRootKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIncludeSubdirs();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getFilePattern();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDirectoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.receptorutil.DirectoryScanNode.serializeBinaryToWriter
    );
  }
  f = message.getEvidencesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      attachment_attachment_pb.Evidence.serializeBinaryToWriter
    );
  }
};


/**
 * optional string root_path = 1;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.getRootPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanResponse} returns this
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.setRootPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string root_key = 2;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.getRootKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanResponse} returns this
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.setRootKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool include_subdirs = 3;
 * @return {boolean}
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.getIncludeSubdirs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.GetDirectoryScanResponse} returns this
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.setIncludeSubdirs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string file_pattern = 4;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.getFilePattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanResponse} returns this
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.setFilePattern = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated DirectoryScanNode directories = 5;
 * @return {!Array<!proto.receptorutil.DirectoryScanNode>}
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.getDirectoriesList = function() {
  return /** @type{!Array<!proto.receptorutil.DirectoryScanNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.DirectoryScanNode, 5));
};


/**
 * @param {!Array<!proto.receptorutil.DirectoryScanNode>} value
 * @return {!proto.receptorutil.GetDirectoryScanResponse} returns this
*/
proto.receptorutil.GetDirectoryScanResponse.prototype.setDirectoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.receptorutil.DirectoryScanNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.DirectoryScanNode}
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.addDirectories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.receptorutil.DirectoryScanNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetDirectoryScanResponse} returns this
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.clearDirectoriesList = function() {
  return this.setDirectoriesList([]);
};


/**
 * repeated attachment.Evidence evidences = 6;
 * @return {!Array<!proto.attachment.Evidence>}
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.getEvidencesList = function() {
  return /** @type{!Array<!proto.attachment.Evidence>} */ (
    jspb.Message.getRepeatedWrapperField(this, attachment_attachment_pb.Evidence, 6));
};


/**
 * @param {!Array<!proto.attachment.Evidence>} value
 * @return {!proto.receptorutil.GetDirectoryScanResponse} returns this
*/
proto.receptorutil.GetDirectoryScanResponse.prototype.setEvidencesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.attachment.Evidence=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.Evidence}
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.addEvidences = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.attachment.Evidence, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetDirectoryScanResponse} returns this
 */
proto.receptorutil.GetDirectoryScanResponse.prototype.clearEvidencesList = function() {
  return this.setEvidencesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.ListDirectoryScanSettingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.ListDirectoryScanSettingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    modelId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    includeOutOfWindow: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    auditId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.ListDirectoryScanSettingsRequest}
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.ListDirectoryScanSettingsRequest;
  return proto.receptorutil.ListDirectoryScanSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.ListDirectoryScanSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.ListDirectoryScanSettingsRequest}
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceptorId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelId(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeOutOfWindow(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.ListDirectoryScanSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.ListDirectoryScanSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getModelId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIncludeOutOfWindow();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * repeated string receptor_id = 1;
 * @return {!Array<string>}
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.getReceptorIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.receptorutil.ListDirectoryScanSettingsRequest} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.setReceptorIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.ListDirectoryScanSettingsRequest} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.addReceptorId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.ListDirectoryScanSettingsRequest} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.clearReceptorIdList = function() {
  return this.setReceptorIdList([]);
};


/**
 * optional uint32 page_size = 2;
 * @return {number}
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.ListDirectoryScanSettingsRequest} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 page_number = 3;
 * @return {number}
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.ListDirectoryScanSettingsRequest} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string model_id = 4;
 * @return {string}
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.getModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.ListDirectoryScanSettingsRequest} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.setModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool include_out_of_window = 5;
 * @return {boolean}
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.getIncludeOutOfWindow = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.ListDirectoryScanSettingsRequest} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.setIncludeOutOfWindow = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string audit_id = 6;
 * @return {string}
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.ListDirectoryScanSettingsRequest} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.DirectoryScanSettingSummary.repeatedFields_ = [16];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.DirectoryScanSettingSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.DirectoryScanSettingSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DirectoryScanSettingSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rootPath: jspb.Message.getFieldWithDefault(msg, 3, ""),
    rootKey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    includeSubdirs: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    filePattern: jspb.Message.getFieldWithDefault(msg, 6, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 7, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
    receptorId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    description: jspb.Message.getFieldWithDefault(msg, 10, ""),
    documentType: jspb.Message.getFieldWithDefault(msg, 11, 0),
    evidenceCount: jspb.Message.getFieldWithDefault(msg, 12, 0),
    modelId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    includeAttachments: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    evidencePrefix: jspb.Message.getFieldWithDefault(msg, 15, ""),
    controlModelIdsList: (f = jspb.Message.getRepeatedField(msg, 16)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.DirectoryScanSettingSummary}
 */
proto.receptorutil.DirectoryScanSettingSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.DirectoryScanSettingSummary;
  return proto.receptorutil.DirectoryScanSettingSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.DirectoryScanSettingSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.DirectoryScanSettingSummary}
 */
proto.receptorutil.DirectoryScanSettingSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootPath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootKey(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeSubdirs(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilePattern(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 11:
      var value = /** @type {!proto.attachment.DOCUMENT_TYPE} */ (reader.readEnum());
      msg.setDocumentType(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setEvidenceCount(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setModelId(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeAttachments(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidencePrefix(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.addControlModelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.DirectoryScanSettingSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.DirectoryScanSettingSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DirectoryScanSettingSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRootPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRootKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIncludeSubdirs();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getFilePattern();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDocumentType();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getEvidenceCount();
  if (f !== 0) {
    writer.writeUint32(
      12,
      f
    );
  }
  f = message.getModelId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getIncludeAttachments();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getEvidencePrefix();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getControlModelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      16,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string root_path = 3;
 * @return {string}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getRootPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setRootPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string root_key = 4;
 * @return {string}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getRootKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setRootKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool include_subdirs = 5;
 * @return {boolean}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getIncludeSubdirs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setIncludeSubdirs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string file_pattern = 6;
 * @return {string}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getFilePattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setFilePattern = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 created_at = 7;
 * @return {number}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 updated_at = 8;
 * @return {number}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string receptor_id = 9;
 * @return {string}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string description = 10;
 * @return {string}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional attachment.DOCUMENT_TYPE document_type = 11;
 * @return {!proto.attachment.DOCUMENT_TYPE}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getDocumentType = function() {
  return /** @type {!proto.attachment.DOCUMENT_TYPE} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.attachment.DOCUMENT_TYPE} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setDocumentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional uint32 evidence_count = 12;
 * @return {number}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getEvidenceCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setEvidenceCount = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional string model_id = 13;
 * @return {string}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool include_attachments = 14;
 * @return {boolean}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getIncludeAttachments = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setIncludeAttachments = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string evidence_prefix = 15;
 * @return {string}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getEvidencePrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setEvidencePrefix = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * repeated string control_model_ids = 16;
 * @return {!Array<string>}
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.getControlModelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 16));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.setControlModelIdsList = function(value) {
  return jspb.Message.setField(this, 16, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.addControlModelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 16, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.DirectoryScanSettingSummary} returns this
 */
proto.receptorutil.DirectoryScanSettingSummary.prototype.clearControlModelIdsList = function() {
  return this.setControlModelIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.ListDirectoryScanSettingsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.ListDirectoryScanSettingsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    settingsList: jspb.Message.toObjectList(msg.getSettingsList(),
    proto.receptorutil.DirectoryScanSettingSummary.toObject, includeInstance),
    pageSize: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    totalCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
    outOfWindowCount: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.ListDirectoryScanSettingsResponse}
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.ListDirectoryScanSettingsResponse;
  return proto.receptorutil.ListDirectoryScanSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.ListDirectoryScanSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.ListDirectoryScanSettingsResponse}
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.receptorutil.DirectoryScanSettingSummary;
      reader.readMessage(value,proto.receptorutil.DirectoryScanSettingSummary.deserializeBinaryFromReader);
      msg.addSettings(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageSize(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPageNumber(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalCount(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOutOfWindowCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.ListDirectoryScanSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.ListDirectoryScanSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.receptorutil.DirectoryScanSettingSummary.serializeBinaryToWriter
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getTotalCount();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getOutOfWindowCount();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * repeated DirectoryScanSettingSummary settings = 1;
 * @return {!Array<!proto.receptorutil.DirectoryScanSettingSummary>}
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.getSettingsList = function() {
  return /** @type{!Array<!proto.receptorutil.DirectoryScanSettingSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.DirectoryScanSettingSummary, 1));
};


/**
 * @param {!Array<!proto.receptorutil.DirectoryScanSettingSummary>} value
 * @return {!proto.receptorutil.ListDirectoryScanSettingsResponse} returns this
*/
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.setSettingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.receptorutil.DirectoryScanSettingSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.DirectoryScanSettingSummary}
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.addSettings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.receptorutil.DirectoryScanSettingSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.ListDirectoryScanSettingsResponse} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.clearSettingsList = function() {
  return this.setSettingsList([]);
};


/**
 * optional uint32 page_size = 2;
 * @return {number}
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.ListDirectoryScanSettingsResponse} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 page_number = 3;
 * @return {number}
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.ListDirectoryScanSettingsResponse} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 total_count = 4;
 * @return {number}
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.getTotalCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.ListDirectoryScanSettingsResponse} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.setTotalCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 out_of_window_count = 5;
 * @return {number}
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.getOutOfWindowCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.ListDirectoryScanSettingsResponse} returns this
 */
proto.receptorutil.ListDirectoryScanSettingsResponse.prototype.setOutOfWindowCount = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.GetDirectoryScanSettingRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetDirectoryScanSettingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetDirectoryScanSettingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanSettingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    scanSettingId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rootKey: jspb.Message.getFieldWithDefault(msg, 3, ""),
    parentKey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    maxDepth: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetDirectoryScanSettingRequest}
 */
proto.receptorutil.GetDirectoryScanSettingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetDirectoryScanSettingRequest;
  return proto.receptorutil.GetDirectoryScanSettingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetDirectoryScanSettingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetDirectoryScanSettingRequest}
 */
proto.receptorutil.GetDirectoryScanSettingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceptorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScanSettingId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentKey(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxDepth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetDirectoryScanSettingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetDirectoryScanSettingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanSettingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getScanSettingId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRootKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getParentKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMaxDepth();
  if (f !== 0) {
    writer.writeUint32(
      5,
      f
    );
  }
};


/**
 * repeated string receptor_id = 1;
 * @return {!Array<string>}
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.getReceptorIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.receptorutil.GetDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.setReceptorIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.GetDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.addReceptorId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.clearReceptorIdList = function() {
  return this.setReceptorIdList([]);
};


/**
 * optional string scan_setting_id = 2;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.getScanSettingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.setScanSettingId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string root_key = 3;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.getRootKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.setRootKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string parent_key = 4;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.getParentKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.setParentKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint32 max_depth = 5;
 * @return {number}
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.getMaxDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.GetDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.GetDirectoryScanSettingRequest.prototype.setMaxDepth = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.GetDirectoryScanSettingResponse.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetDirectoryScanSettingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetDirectoryScanSettingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanSettingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    summary: (f = msg.getSummary()) && proto.receptorutil.DirectoryScanSettingSummary.toObject(includeInstance, f),
    directoriesList: jspb.Message.toObjectList(msg.getDirectoriesList(),
    proto.receptorutil.DirectoryScanNode.toObject, includeInstance),
    evidencesList: jspb.Message.toObjectList(msg.getEvidencesList(),
    attachment_attachment_pb.Evidence.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetDirectoryScanSettingResponse}
 */
proto.receptorutil.GetDirectoryScanSettingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetDirectoryScanSettingResponse;
  return proto.receptorutil.GetDirectoryScanSettingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetDirectoryScanSettingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetDirectoryScanSettingResponse}
 */
proto.receptorutil.GetDirectoryScanSettingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.receptorutil.DirectoryScanSettingSummary;
      reader.readMessage(value,proto.receptorutil.DirectoryScanSettingSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    case 2:
      var value = new proto.receptorutil.DirectoryScanNode;
      reader.readMessage(value,proto.receptorutil.DirectoryScanNode.deserializeBinaryFromReader);
      msg.addDirectories(value);
      break;
    case 3:
      var value = new attachment_attachment_pb.Evidence;
      reader.readMessage(value,attachment_attachment_pb.Evidence.deserializeBinaryFromReader);
      msg.addEvidences(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetDirectoryScanSettingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetDirectoryScanSettingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanSettingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.receptorutil.DirectoryScanSettingSummary.serializeBinaryToWriter
    );
  }
  f = message.getDirectoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.receptorutil.DirectoryScanNode.serializeBinaryToWriter
    );
  }
  f = message.getEvidencesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      attachment_attachment_pb.Evidence.serializeBinaryToWriter
    );
  }
};


/**
 * optional DirectoryScanSettingSummary summary = 1;
 * @return {?proto.receptorutil.DirectoryScanSettingSummary}
 */
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.getSummary = function() {
  return /** @type{?proto.receptorutil.DirectoryScanSettingSummary} */ (
    jspb.Message.getWrapperField(this, proto.receptorutil.DirectoryScanSettingSummary, 1));
};


/**
 * @param {?proto.receptorutil.DirectoryScanSettingSummary|undefined} value
 * @return {!proto.receptorutil.GetDirectoryScanSettingResponse} returns this
*/
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.receptorutil.GetDirectoryScanSettingResponse} returns this
 */
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DirectoryScanNode directories = 2;
 * @return {!Array<!proto.receptorutil.DirectoryScanNode>}
 */
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.getDirectoriesList = function() {
  return /** @type{!Array<!proto.receptorutil.DirectoryScanNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.DirectoryScanNode, 2));
};


/**
 * @param {!Array<!proto.receptorutil.DirectoryScanNode>} value
 * @return {!proto.receptorutil.GetDirectoryScanSettingResponse} returns this
*/
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.setDirectoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.receptorutil.DirectoryScanNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.DirectoryScanNode}
 */
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.addDirectories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.receptorutil.DirectoryScanNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetDirectoryScanSettingResponse} returns this
 */
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.clearDirectoriesList = function() {
  return this.setDirectoriesList([]);
};


/**
 * repeated attachment.Evidence evidences = 3;
 * @return {!Array<!proto.attachment.Evidence>}
 */
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.getEvidencesList = function() {
  return /** @type{!Array<!proto.attachment.Evidence>} */ (
    jspb.Message.getRepeatedWrapperField(this, attachment_attachment_pb.Evidence, 3));
};


/**
 * @param {!Array<!proto.attachment.Evidence>} value
 * @return {!proto.receptorutil.GetDirectoryScanSettingResponse} returns this
*/
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.setEvidencesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.attachment.Evidence=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.Evidence}
 */
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.addEvidences = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.attachment.Evidence, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetDirectoryScanSettingResponse} returns this
 */
proto.receptorutil.GetDirectoryScanSettingResponse.prototype.clearEvidencesList = function() {
  return this.setEvidencesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.AddDirectoryScanSettingRequest.repeatedFields_ = [1,8,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.AddDirectoryScanSettingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.AddDirectoryScanSettingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.AddDirectoryScanSettingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    rootPath: jspb.Message.getFieldWithDefault(msg, 3, ""),
    rootKey: jspb.Message.getFieldWithDefault(msg, 4, ""),
    documentType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    includeSubdirs: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    filePattern: jspb.Message.getFieldWithDefault(msg, 7, ""),
    directoriesList: jspb.Message.toObjectList(msg.getDirectoriesList(),
    proto.receptorutil.DirectoryScanNode.toObject, includeInstance),
    policyModelId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    includeAttachments: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    evidencePrefix: jspb.Message.getFieldWithDefault(msg, 11, ""),
    controlModelIdsList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.AddDirectoryScanSettingRequest;
  return proto.receptorutil.AddDirectoryScanSettingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.AddDirectoryScanSettingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceptorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootPath(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootKey(value);
      break;
    case 5:
      var value = /** @type {!proto.attachment.DOCUMENT_TYPE} */ (reader.readEnum());
      msg.setDocumentType(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeSubdirs(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilePattern(value);
      break;
    case 8:
      var value = new proto.receptorutil.DirectoryScanNode;
      reader.readMessage(value,proto.receptorutil.DirectoryScanNode.deserializeBinaryFromReader);
      msg.addDirectories(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPolicyModelId(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeAttachments(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidencePrefix(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addControlModelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.AddDirectoryScanSettingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.AddDirectoryScanSettingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.AddDirectoryScanSettingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRootPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRootKey();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDocumentType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getIncludeSubdirs();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getFilePattern();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDirectoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.receptorutil.DirectoryScanNode.serializeBinaryToWriter
    );
  }
  f = message.getPolicyModelId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIncludeAttachments();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getEvidencePrefix();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getControlModelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
};


/**
 * repeated string receptor_id = 1;
 * @return {!Array<string>}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getReceptorIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setReceptorIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.addReceptorId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.clearReceptorIdList = function() {
  return this.setReceptorIdList([]);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string root_path = 3;
 * @return {string}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getRootPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setRootPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string root_key = 4;
 * @return {string}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getRootKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setRootKey = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional attachment.DOCUMENT_TYPE document_type = 5;
 * @return {!proto.attachment.DOCUMENT_TYPE}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getDocumentType = function() {
  return /** @type {!proto.attachment.DOCUMENT_TYPE} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.attachment.DOCUMENT_TYPE} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setDocumentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional bool include_subdirs = 6;
 * @return {boolean}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getIncludeSubdirs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setIncludeSubdirs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string file_pattern = 7;
 * @return {string}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getFilePattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setFilePattern = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * repeated DirectoryScanNode directories = 8;
 * @return {!Array<!proto.receptorutil.DirectoryScanNode>}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getDirectoriesList = function() {
  return /** @type{!Array<!proto.receptorutil.DirectoryScanNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.DirectoryScanNode, 8));
};


/**
 * @param {!Array<!proto.receptorutil.DirectoryScanNode>} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
*/
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setDirectoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.receptorutil.DirectoryScanNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.DirectoryScanNode}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.addDirectories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.receptorutil.DirectoryScanNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.clearDirectoriesList = function() {
  return this.setDirectoriesList([]);
};


/**
 * optional string policy_model_id = 9;
 * @return {string}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getPolicyModelId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setPolicyModelId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool include_attachments = 10;
 * @return {boolean}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getIncludeAttachments = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setIncludeAttachments = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string evidence_prefix = 11;
 * @return {string}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getEvidencePrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setEvidencePrefix = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * repeated string control_model_ids = 12;
 * @return {!Array<string>}
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.getControlModelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.setControlModelIdsList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.addControlModelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.AddDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.AddDirectoryScanSettingRequest.prototype.clearControlModelIdsList = function() {
  return this.setControlModelIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.AddDirectoryScanSettingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.AddDirectoryScanSettingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.AddDirectoryScanSettingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.AddDirectoryScanSettingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    summary: (f = msg.getSummary()) && proto.receptorutil.DirectoryScanSettingSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.AddDirectoryScanSettingResponse}
 */
proto.receptorutil.AddDirectoryScanSettingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.AddDirectoryScanSettingResponse;
  return proto.receptorutil.AddDirectoryScanSettingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.AddDirectoryScanSettingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.AddDirectoryScanSettingResponse}
 */
proto.receptorutil.AddDirectoryScanSettingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.receptorutil.DirectoryScanSettingSummary;
      reader.readMessage(value,proto.receptorutil.DirectoryScanSettingSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.AddDirectoryScanSettingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.AddDirectoryScanSettingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.AddDirectoryScanSettingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.AddDirectoryScanSettingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.receptorutil.DirectoryScanSettingSummary.serializeBinaryToWriter
    );
  }
};


/**
 * optional DirectoryScanSettingSummary summary = 1;
 * @return {?proto.receptorutil.DirectoryScanSettingSummary}
 */
proto.receptorutil.AddDirectoryScanSettingResponse.prototype.getSummary = function() {
  return /** @type{?proto.receptorutil.DirectoryScanSettingSummary} */ (
    jspb.Message.getWrapperField(this, proto.receptorutil.DirectoryScanSettingSummary, 1));
};


/**
 * @param {?proto.receptorutil.DirectoryScanSettingSummary|undefined} value
 * @return {!proto.receptorutil.AddDirectoryScanSettingResponse} returns this
*/
proto.receptorutil.AddDirectoryScanSettingResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.receptorutil.AddDirectoryScanSettingResponse} returns this
 */
proto.receptorutil.AddDirectoryScanSettingResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.receptorutil.AddDirectoryScanSettingResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.repeatedFields_ = [1,9,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.UpdateDirectoryScanSettingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.UpdateDirectoryScanSettingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    scanSettingId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    description: jspb.Message.getFieldWithDefault(msg, 3, ""),
    rootPath: jspb.Message.getFieldWithDefault(msg, 4, ""),
    rootKey: jspb.Message.getFieldWithDefault(msg, 5, ""),
    documentType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    includeSubdirs: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    filePattern: jspb.Message.getFieldWithDefault(msg, 8, ""),
    directoriesList: jspb.Message.toObjectList(msg.getDirectoriesList(),
    proto.receptorutil.DirectoryScanNode.toObject, includeInstance),
    includeAttachments: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    evidencePrefix: jspb.Message.getFieldWithDefault(msg, 11, ""),
    controlModelIdsList: (f = jspb.Message.getRepeatedField(msg, 12)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.UpdateDirectoryScanSettingRequest;
  return proto.receptorutil.UpdateDirectoryScanSettingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.UpdateDirectoryScanSettingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceptorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScanSettingId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootPath(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootKey(value);
      break;
    case 6:
      var value = /** @type {!proto.attachment.DOCUMENT_TYPE} */ (reader.readEnum());
      msg.setDocumentType(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeSubdirs(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFilePattern(value);
      break;
    case 9:
      var value = new proto.receptorutil.DirectoryScanNode;
      reader.readMessage(value,proto.receptorutil.DirectoryScanNode.deserializeBinaryFromReader);
      msg.addDirectories(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeAttachments(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setEvidencePrefix(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.addControlModelIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.UpdateDirectoryScanSettingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.UpdateDirectoryScanSettingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getScanSettingId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRootPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRootKey();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDocumentType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getIncludeSubdirs();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getFilePattern();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDirectoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.receptorutil.DirectoryScanNode.serializeBinaryToWriter
    );
  }
  f = message.getIncludeAttachments();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getEvidencePrefix();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getControlModelIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      12,
      f
    );
  }
};


/**
 * repeated string receptor_id = 1;
 * @return {!Array<string>}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getReceptorIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setReceptorIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.addReceptorId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.clearReceptorIdList = function() {
  return this.setReceptorIdList([]);
};


/**
 * optional string scan_setting_id = 2;
 * @return {string}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getScanSettingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setScanSettingId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string description = 3;
 * @return {string}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string root_path = 4;
 * @return {string}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getRootPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setRootPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string root_key = 5;
 * @return {string}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getRootKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setRootKey = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional attachment.DOCUMENT_TYPE document_type = 6;
 * @return {!proto.attachment.DOCUMENT_TYPE}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getDocumentType = function() {
  return /** @type {!proto.attachment.DOCUMENT_TYPE} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.attachment.DOCUMENT_TYPE} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setDocumentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional bool include_subdirs = 7;
 * @return {boolean}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getIncludeSubdirs = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setIncludeSubdirs = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string file_pattern = 8;
 * @return {string}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getFilePattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setFilePattern = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated DirectoryScanNode directories = 9;
 * @return {!Array<!proto.receptorutil.DirectoryScanNode>}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getDirectoriesList = function() {
  return /** @type{!Array<!proto.receptorutil.DirectoryScanNode>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.DirectoryScanNode, 9));
};


/**
 * @param {!Array<!proto.receptorutil.DirectoryScanNode>} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
*/
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setDirectoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.receptorutil.DirectoryScanNode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.DirectoryScanNode}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.addDirectories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.receptorutil.DirectoryScanNode, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.clearDirectoriesList = function() {
  return this.setDirectoriesList([]);
};


/**
 * optional bool include_attachments = 10;
 * @return {boolean}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getIncludeAttachments = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setIncludeAttachments = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string evidence_prefix = 11;
 * @return {string}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getEvidencePrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setEvidencePrefix = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * repeated string control_model_ids = 12;
 * @return {!Array<string>}
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.getControlModelIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 12));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.setControlModelIdsList = function(value) {
  return jspb.Message.setField(this, 12, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.addControlModelIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 12, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingRequest.prototype.clearControlModelIdsList = function() {
  return this.setControlModelIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.UpdateDirectoryScanSettingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.UpdateDirectoryScanSettingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.UpdateDirectoryScanSettingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.UpdateDirectoryScanSettingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    summary: (f = msg.getSummary()) && proto.receptorutil.DirectoryScanSettingSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingResponse}
 */
proto.receptorutil.UpdateDirectoryScanSettingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.UpdateDirectoryScanSettingResponse;
  return proto.receptorutil.UpdateDirectoryScanSettingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.UpdateDirectoryScanSettingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingResponse}
 */
proto.receptorutil.UpdateDirectoryScanSettingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.receptorutil.DirectoryScanSettingSummary;
      reader.readMessage(value,proto.receptorutil.DirectoryScanSettingSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.UpdateDirectoryScanSettingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.UpdateDirectoryScanSettingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.UpdateDirectoryScanSettingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.UpdateDirectoryScanSettingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.receptorutil.DirectoryScanSettingSummary.serializeBinaryToWriter
    );
  }
};


/**
 * optional DirectoryScanSettingSummary summary = 1;
 * @return {?proto.receptorutil.DirectoryScanSettingSummary}
 */
proto.receptorutil.UpdateDirectoryScanSettingResponse.prototype.getSummary = function() {
  return /** @type{?proto.receptorutil.DirectoryScanSettingSummary} */ (
    jspb.Message.getWrapperField(this, proto.receptorutil.DirectoryScanSettingSummary, 1));
};


/**
 * @param {?proto.receptorutil.DirectoryScanSettingSummary|undefined} value
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingResponse} returns this
*/
proto.receptorutil.UpdateDirectoryScanSettingResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.receptorutil.UpdateDirectoryScanSettingResponse} returns this
 */
proto.receptorutil.UpdateDirectoryScanSettingResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.receptorutil.UpdateDirectoryScanSettingResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.DeleteDirectoryScanSettingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.DeleteDirectoryScanSettingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorIdList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    scanSettingId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.DeleteDirectoryScanSettingRequest}
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.DeleteDirectoryScanSettingRequest;
  return proto.receptorutil.DeleteDirectoryScanSettingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.DeleteDirectoryScanSettingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.DeleteDirectoryScanSettingRequest}
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addReceptorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setScanSettingId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.DeleteDirectoryScanSettingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.DeleteDirectoryScanSettingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorIdList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getScanSettingId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated string receptor_id = 1;
 * @return {!Array<string>}
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.prototype.getReceptorIdList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.receptorutil.DeleteDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.prototype.setReceptorIdList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.DeleteDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.prototype.addReceptorId = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.DeleteDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.prototype.clearReceptorIdList = function() {
  return this.setReceptorIdList([]);
};


/**
 * optional string scan_setting_id = 2;
 * @return {string}
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.prototype.getScanSettingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DeleteDirectoryScanSettingRequest} returns this
 */
proto.receptorutil.DeleteDirectoryScanSettingRequest.prototype.setScanSettingId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.DeleteDirectoryScanSettingResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.DeleteDirectoryScanSettingResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.DeleteDirectoryScanSettingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DeleteDirectoryScanSettingResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    scanSettingId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.DeleteDirectoryScanSettingResponse}
 */
proto.receptorutil.DeleteDirectoryScanSettingResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.DeleteDirectoryScanSettingResponse;
  return proto.receptorutil.DeleteDirectoryScanSettingResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.DeleteDirectoryScanSettingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.DeleteDirectoryScanSettingResponse}
 */
proto.receptorutil.DeleteDirectoryScanSettingResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScanSettingId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.DeleteDirectoryScanSettingResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.DeleteDirectoryScanSettingResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.DeleteDirectoryScanSettingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.DeleteDirectoryScanSettingResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScanSettingId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string scan_setting_id = 1;
 * @return {string}
 */
proto.receptorutil.DeleteDirectoryScanSettingResponse.prototype.getScanSettingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.DeleteDirectoryScanSettingResponse} returns this
 */
proto.receptorutil.DeleteDirectoryScanSettingResponse.prototype.setScanSettingId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetDirectoryScanSettingEvidencesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    scanSettingId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetDirectoryScanSettingEvidencesRequest}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetDirectoryScanSettingEvidencesRequest;
  return proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetDirectoryScanSettingEvidencesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetDirectoryScanSettingEvidencesRequest}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScanSettingId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetDirectoryScanSettingEvidencesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScanSettingId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string scan_setting_id = 1;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.prototype.getScanSettingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanSettingEvidencesRequest} returns this
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesRequest.prototype.setScanSettingId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetDirectoryScanSettingEvidencesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    scanSettingId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    evidencesList: jspb.Message.toObjectList(msg.getEvidencesList(),
    attachment_attachment_pb.Evidence.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetDirectoryScanSettingEvidencesResponse}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetDirectoryScanSettingEvidencesResponse;
  return proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetDirectoryScanSettingEvidencesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetDirectoryScanSettingEvidencesResponse}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setScanSettingId(value);
      break;
    case 2:
      var value = new attachment_attachment_pb.Evidence;
      reader.readMessage(value,attachment_attachment_pb.Evidence.deserializeBinaryFromReader);
      msg.addEvidences(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetDirectoryScanSettingEvidencesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getScanSettingId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEvidencesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      attachment_attachment_pb.Evidence.serializeBinaryToWriter
    );
  }
};


/**
 * optional string scan_setting_id = 1;
 * @return {string}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.prototype.getScanSettingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetDirectoryScanSettingEvidencesResponse} returns this
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.prototype.setScanSettingId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated attachment.Evidence evidences = 2;
 * @return {!Array<!proto.attachment.Evidence>}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.prototype.getEvidencesList = function() {
  return /** @type{!Array<!proto.attachment.Evidence>} */ (
    jspb.Message.getRepeatedWrapperField(this, attachment_attachment_pb.Evidence, 2));
};


/**
 * @param {!Array<!proto.attachment.Evidence>} value
 * @return {!proto.receptorutil.GetDirectoryScanSettingEvidencesResponse} returns this
*/
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.prototype.setEvidencesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.attachment.Evidence=} opt_value
 * @param {number=} opt_index
 * @return {!proto.attachment.Evidence}
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.prototype.addEvidences = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.attachment.Evidence, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetDirectoryScanSettingEvidencesResponse} returns this
 */
proto.receptorutil.GetDirectoryScanSettingEvidencesResponse.prototype.clearEvidencesList = function() {
  return this.setEvidencesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.WorkflowTicket.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.WorkflowTicket.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.WorkflowTicket} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.WorkflowTicket.toObject = function(includeInstance, msg) {
  var f, obj = {
    sourceId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sourceKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    title: jspb.Message.getFieldWithDefault(msg, 3, ""),
    url: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.WorkflowTicket}
 */
proto.receptorutil.WorkflowTicket.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.WorkflowTicket;
  return proto.receptorutil.WorkflowTicket.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.WorkflowTicket} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.WorkflowTicket}
 */
proto.receptorutil.WorkflowTicket.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceKey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.WorkflowTicket.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.WorkflowTicket.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.WorkflowTicket} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.WorkflowTicket.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSourceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSourceKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional string source_id = 1;
 * @return {string}
 */
proto.receptorutil.WorkflowTicket.prototype.getSourceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.WorkflowTicket} returns this
 */
proto.receptorutil.WorkflowTicket.prototype.setSourceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string source_key = 2;
 * @return {string}
 */
proto.receptorutil.WorkflowTicket.prototype.getSourceKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.WorkflowTicket} returns this
 */
proto.receptorutil.WorkflowTicket.prototype.setSourceKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.receptorutil.WorkflowTicket.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.WorkflowTicket} returns this
 */
proto.receptorutil.WorkflowTicket.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string url = 4;
 * @return {string}
 */
proto.receptorutil.WorkflowTicket.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.WorkflowTicket} returns this
 */
proto.receptorutil.WorkflowTicket.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string status = 5;
 * @return {string}
 */
proto.receptorutil.WorkflowTicket.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.WorkflowTicket} returns this
 */
proto.receptorutil.WorkflowTicket.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.receptorutil.WorkflowTicket.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.WorkflowTicket} returns this
 */
proto.receptorutil.WorkflowTicket.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 updated_at = 7;
 * @return {number}
 */
proto.receptorutil.WorkflowTicket.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.WorkflowTicket} returns this
 */
proto.receptorutil.WorkflowTicket.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.FindWorkflowTicketByTitleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.FindWorkflowTicketByTitleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    title: jspb.Message.getFieldWithDefault(msg, 2, ""),
    lookbackMinutes: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleRequest}
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.FindWorkflowTicketByTitleRequest;
  return proto.receptorutil.FindWorkflowTicketByTitleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.FindWorkflowTicketByTitleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleRequest}
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLookbackMinutes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.FindWorkflowTicketByTitleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.FindWorkflowTicketByTitleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLookbackMinutes();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleRequest} returns this
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleRequest} returns this
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 lookback_minutes = 3;
 * @return {number}
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.prototype.getLookbackMinutes = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleRequest} returns this
 */
proto.receptorutil.FindWorkflowTicketByTitleRequest.prototype.setLookbackMinutes = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.FindWorkflowTicketByTitleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.FindWorkflowTicketByTitleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    found: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    ticket: (f = msg.getTicket()) && proto.receptorutil.WorkflowTicket.toObject(includeInstance, f),
    ambiguous: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    candidateCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleResponse}
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.FindWorkflowTicketByTitleResponse;
  return proto.receptorutil.FindWorkflowTicketByTitleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.FindWorkflowTicketByTitleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleResponse}
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFound(value);
      break;
    case 2:
      var value = new proto.receptorutil.WorkflowTicket;
      reader.readMessage(value,proto.receptorutil.WorkflowTicket.deserializeBinaryFromReader);
      msg.setTicket(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAmbiguous(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCandidateCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.FindWorkflowTicketByTitleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.FindWorkflowTicketByTitleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFound();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getTicket();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.receptorutil.WorkflowTicket.serializeBinaryToWriter
    );
  }
  f = message.getAmbiguous();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCandidateCount();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional bool found = 1;
 * @return {boolean}
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.getFound = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleResponse} returns this
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.setFound = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional WorkflowTicket ticket = 2;
 * @return {?proto.receptorutil.WorkflowTicket}
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.getTicket = function() {
  return /** @type{?proto.receptorutil.WorkflowTicket} */ (
    jspb.Message.getWrapperField(this, proto.receptorutil.WorkflowTicket, 2));
};


/**
 * @param {?proto.receptorutil.WorkflowTicket|undefined} value
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleResponse} returns this
*/
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.setTicket = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleResponse} returns this
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.clearTicket = function() {
  return this.setTicket(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.hasTicket = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool ambiguous = 3;
 * @return {boolean}
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.getAmbiguous = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleResponse} returns this
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.setAmbiguous = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional uint32 candidate_count = 4;
 * @return {number}
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.getCandidateCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.FindWorkflowTicketByTitleResponse} returns this
 */
proto.receptorutil.FindWorkflowTicketByTitleResponse.prototype.setCandidateCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetWorkflowTicketStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetWorkflowTicketStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetWorkflowTicketStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetWorkflowTicketStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sourceId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetWorkflowTicketStatusRequest}
 */
proto.receptorutil.GetWorkflowTicketStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetWorkflowTicketStatusRequest;
  return proto.receptorutil.GetWorkflowTicketStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetWorkflowTicketStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetWorkflowTicketStatusRequest}
 */
proto.receptorutil.GetWorkflowTicketStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetWorkflowTicketStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetWorkflowTicketStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetWorkflowTicketStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetWorkflowTicketStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSourceId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.receptorutil.GetWorkflowTicketStatusRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetWorkflowTicketStatusRequest} returns this
 */
proto.receptorutil.GetWorkflowTicketStatusRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string source_id = 2;
 * @return {string}
 */
proto.receptorutil.GetWorkflowTicketStatusRequest.prototype.getSourceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetWorkflowTicketStatusRequest} returns this
 */
proto.receptorutil.GetWorkflowTicketStatusRequest.prototype.setSourceId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetWorkflowTicketStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetWorkflowTicketStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, ""),
    url: jspb.Message.getFieldWithDefault(msg, 2, ""),
    lastCheckedAt: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetWorkflowTicketStatusResponse}
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetWorkflowTicketStatusResponse;
  return proto.receptorutil.GetWorkflowTicketStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetWorkflowTicketStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetWorkflowTicketStatusResponse}
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLastCheckedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetWorkflowTicketStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetWorkflowTicketStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLastCheckedAt();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional string status = 1;
 * @return {string}
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetWorkflowTicketStatusResponse} returns this
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetWorkflowTicketStatusResponse} returns this
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 last_checked_at = 3;
 * @return {number}
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.prototype.getLastCheckedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.GetWorkflowTicketStatusResponse} returns this
 */
proto.receptorutil.GetWorkflowTicketStatusResponse.prototype.setLastCheckedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.WorkflowUser.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.WorkflowUser.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.WorkflowUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.WorkflowUser.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    email: jspb.Message.getFieldWithDefault(msg, 3, ""),
    active: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    avatarUrl: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.WorkflowUser}
 */
proto.receptorutil.WorkflowUser.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.WorkflowUser;
  return proto.receptorutil.WorkflowUser.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.WorkflowUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.WorkflowUser}
 */
proto.receptorutil.WorkflowUser.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setActive(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.WorkflowUser.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.WorkflowUser.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.WorkflowUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.WorkflowUser.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActive();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getAvatarUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.receptorutil.WorkflowUser.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.WorkflowUser} returns this
 */
proto.receptorutil.WorkflowUser.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.receptorutil.WorkflowUser.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.WorkflowUser} returns this
 */
proto.receptorutil.WorkflowUser.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.receptorutil.WorkflowUser.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.WorkflowUser} returns this
 */
proto.receptorutil.WorkflowUser.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional bool active = 4;
 * @return {boolean}
 */
proto.receptorutil.WorkflowUser.prototype.getActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.WorkflowUser} returns this
 */
proto.receptorutil.WorkflowUser.prototype.setActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional string avatar_url = 5;
 * @return {string}
 */
proto.receptorutil.WorkflowUser.prototype.getAvatarUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.WorkflowUser} returns this
 */
proto.receptorutil.WorkflowUser.prototype.setAvatarUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetWorkflowUsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetWorkflowUsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetWorkflowUsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetWorkflowUsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    query: jspb.Message.getFieldWithDefault(msg, 3, ""),
    maxResults: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetWorkflowUsersRequest}
 */
proto.receptorutil.GetWorkflowUsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetWorkflowUsersRequest;
  return proto.receptorutil.GetWorkflowUsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetWorkflowUsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetWorkflowUsersRequest}
 */
proto.receptorutil.GetWorkflowUsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setQuery(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setMaxResults(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetWorkflowUsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetWorkflowUsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetWorkflowUsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetWorkflowUsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQuery();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMaxResults();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.receptorutil.GetWorkflowUsersRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetWorkflowUsersRequest} returns this
 */
proto.receptorutil.GetWorkflowUsersRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.receptorutil.GetWorkflowUsersRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetWorkflowUsersRequest} returns this
 */
proto.receptorutil.GetWorkflowUsersRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string query = 3;
 * @return {string}
 */
proto.receptorutil.GetWorkflowUsersRequest.prototype.getQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetWorkflowUsersRequest} returns this
 */
proto.receptorutil.GetWorkflowUsersRequest.prototype.setQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 max_results = 4;
 * @return {number}
 */
proto.receptorutil.GetWorkflowUsersRequest.prototype.getMaxResults = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.receptorutil.GetWorkflowUsersRequest} returns this
 */
proto.receptorutil.GetWorkflowUsersRequest.prototype.setMaxResults = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.GetWorkflowUsersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetWorkflowUsersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetWorkflowUsersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetWorkflowUsersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetWorkflowUsersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.receptorutil.WorkflowUser.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetWorkflowUsersResponse}
 */
proto.receptorutil.GetWorkflowUsersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetWorkflowUsersResponse;
  return proto.receptorutil.GetWorkflowUsersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetWorkflowUsersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetWorkflowUsersResponse}
 */
proto.receptorutil.GetWorkflowUsersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.receptorutil.WorkflowUser;
      reader.readMessage(value,proto.receptorutil.WorkflowUser.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetWorkflowUsersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetWorkflowUsersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetWorkflowUsersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetWorkflowUsersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.receptorutil.WorkflowUser.serializeBinaryToWriter
    );
  }
};


/**
 * repeated WorkflowUser users = 1;
 * @return {!Array<!proto.receptorutil.WorkflowUser>}
 */
proto.receptorutil.GetWorkflowUsersResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.receptorutil.WorkflowUser>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.WorkflowUser, 1));
};


/**
 * @param {!Array<!proto.receptorutil.WorkflowUser>} value
 * @return {!proto.receptorutil.GetWorkflowUsersResponse} returns this
*/
proto.receptorutil.GetWorkflowUsersResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.receptorutil.WorkflowUser=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.WorkflowUser}
 */
proto.receptorutil.GetWorkflowUsersResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.receptorutil.WorkflowUser, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.GetWorkflowUsersResponse} returns this
 */
proto.receptorutil.GetWorkflowUsersResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.CreateWorkflowTicketRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.CreateWorkflowTicketRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.CreateWorkflowTicketRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    projectId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    taskTypeId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    title: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    label: jspb.Message.getFieldWithDefault(msg, 6, ""),
    assigneeId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    requestId: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.CreateWorkflowTicketRequest}
 */
proto.receptorutil.CreateWorkflowTicketRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.CreateWorkflowTicketRequest;
  return proto.receptorutil.CreateWorkflowTicketRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.CreateWorkflowTicketRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.CreateWorkflowTicketRequest}
 */
proto.receptorutil.CreateWorkflowTicketRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProjectId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskTypeId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAssigneeId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRequestId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.CreateWorkflowTicketRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.CreateWorkflowTicketRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.CreateWorkflowTicketRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProjectId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTaskTypeId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAssigneeId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getRequestId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CreateWorkflowTicketRequest} returns this
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string project_id = 2;
 * @return {string}
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.getProjectId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CreateWorkflowTicketRequest} returns this
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.setProjectId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string task_type_id = 3;
 * @return {string}
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.getTaskTypeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CreateWorkflowTicketRequest} returns this
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.setTaskTypeId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CreateWorkflowTicketRequest} returns this
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CreateWorkflowTicketRequest} returns this
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string label = 6;
 * @return {string}
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CreateWorkflowTicketRequest} returns this
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string assignee_id = 7;
 * @return {string}
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.getAssigneeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CreateWorkflowTicketRequest} returns this
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.setAssigneeId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string request_id = 8;
 * @return {string}
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.getRequestId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CreateWorkflowTicketRequest} returns this
 */
proto.receptorutil.CreateWorkflowTicketRequest.prototype.setRequestId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.CreateWorkflowTicketResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.CreateWorkflowTicketResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.CreateWorkflowTicketResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.CreateWorkflowTicketResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    ticketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    ticketKey: jspb.Message.getFieldWithDefault(msg, 2, ""),
    ticketUrl: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.CreateWorkflowTicketResponse}
 */
proto.receptorutil.CreateWorkflowTicketResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.CreateWorkflowTicketResponse;
  return proto.receptorutil.CreateWorkflowTicketResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.CreateWorkflowTicketResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.CreateWorkflowTicketResponse}
 */
proto.receptorutil.CreateWorkflowTicketResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketKey(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTicketUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.CreateWorkflowTicketResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.CreateWorkflowTicketResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.CreateWorkflowTicketResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.CreateWorkflowTicketResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTicketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTicketKey();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTicketUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string ticket_id = 1;
 * @return {string}
 */
proto.receptorutil.CreateWorkflowTicketResponse.prototype.getTicketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CreateWorkflowTicketResponse} returns this
 */
proto.receptorutil.CreateWorkflowTicketResponse.prototype.setTicketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string ticket_key = 2;
 * @return {string}
 */
proto.receptorutil.CreateWorkflowTicketResponse.prototype.getTicketKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CreateWorkflowTicketResponse} returns this
 */
proto.receptorutil.CreateWorkflowTicketResponse.prototype.setTicketKey = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ticket_url = 3;
 * @return {string}
 */
proto.receptorutil.CreateWorkflowTicketResponse.prototype.getTicketUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CreateWorkflowTicketResponse} returns this
 */
proto.receptorutil.CreateWorkflowTicketResponse.prototype.setTicketUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.CheckReceptorFileAccessRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.CheckReceptorFileAccessRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.CheckReceptorFileAccessRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.CheckReceptorFileAccessRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.CheckReceptorFileAccessRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    receptorId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fileIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.CheckReceptorFileAccessRequest}
 */
proto.receptorutil.CheckReceptorFileAccessRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.CheckReceptorFileAccessRequest;
  return proto.receptorutil.CheckReceptorFileAccessRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.CheckReceptorFileAccessRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.CheckReceptorFileAccessRequest}
 */
proto.receptorutil.CheckReceptorFileAccessRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addFileIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.CheckReceptorFileAccessRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.CheckReceptorFileAccessRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.CheckReceptorFileAccessRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.CheckReceptorFileAccessRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceptorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFileIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string receptor_id = 1;
 * @return {string}
 */
proto.receptorutil.CheckReceptorFileAccessRequest.prototype.getReceptorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CheckReceptorFileAccessRequest} returns this
 */
proto.receptorutil.CheckReceptorFileAccessRequest.prototype.setReceptorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string file_ids = 2;
 * @return {!Array<string>}
 */
proto.receptorutil.CheckReceptorFileAccessRequest.prototype.getFileIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.receptorutil.CheckReceptorFileAccessRequest} returns this
 */
proto.receptorutil.CheckReceptorFileAccessRequest.prototype.setFileIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.CheckReceptorFileAccessRequest} returns this
 */
proto.receptorutil.CheckReceptorFileAccessRequest.prototype.addFileIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.CheckReceptorFileAccessRequest} returns this
 */
proto.receptorutil.CheckReceptorFileAccessRequest.prototype.clearFileIdsList = function() {
  return this.setFileIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.ReceptorFileAccess.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.ReceptorFileAccess.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.ReceptorFileAccess} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.ReceptorFileAccess.toObject = function(includeInstance, msg) {
  var f, obj = {
    fileId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accessible: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    mimeType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    url: jspb.Message.getFieldWithDefault(msg, 5, ""),
    error: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.ReceptorFileAccess}
 */
proto.receptorutil.ReceptorFileAccess.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.ReceptorFileAccess;
  return proto.receptorutil.ReceptorFileAccess.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.ReceptorFileAccess} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.ReceptorFileAccess}
 */
proto.receptorutil.ReceptorFileAccess.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccessible(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.ReceptorFileAccess.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.ReceptorFileAccess.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.ReceptorFileAccess} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.ReceptorFileAccess.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccessible();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getError();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string file_id = 1;
 * @return {string}
 */
proto.receptorutil.ReceptorFileAccess.prototype.getFileId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.ReceptorFileAccess} returns this
 */
proto.receptorutil.ReceptorFileAccess.prototype.setFileId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool accessible = 2;
 * @return {boolean}
 */
proto.receptorutil.ReceptorFileAccess.prototype.getAccessible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.receptorutil.ReceptorFileAccess} returns this
 */
proto.receptorutil.ReceptorFileAccess.prototype.setAccessible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.receptorutil.ReceptorFileAccess.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.ReceptorFileAccess} returns this
 */
proto.receptorutil.ReceptorFileAccess.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string mime_type = 4;
 * @return {string}
 */
proto.receptorutil.ReceptorFileAccess.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.ReceptorFileAccess} returns this
 */
proto.receptorutil.ReceptorFileAccess.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string url = 5;
 * @return {string}
 */
proto.receptorutil.ReceptorFileAccess.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.ReceptorFileAccess} returns this
 */
proto.receptorutil.ReceptorFileAccess.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string error = 6;
 * @return {string}
 */
proto.receptorutil.ReceptorFileAccess.prototype.getError = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.ReceptorFileAccess} returns this
 */
proto.receptorutil.ReceptorFileAccess.prototype.setError = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.receptorutil.CheckReceptorFileAccessResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.CheckReceptorFileAccessResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.CheckReceptorFileAccessResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.CheckReceptorFileAccessResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.CheckReceptorFileAccessResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    resultsList: jspb.Message.toObjectList(msg.getResultsList(),
    proto.receptorutil.ReceptorFileAccess.toObject, includeInstance),
    receptorIdentity: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.CheckReceptorFileAccessResponse}
 */
proto.receptorutil.CheckReceptorFileAccessResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.CheckReceptorFileAccessResponse;
  return proto.receptorutil.CheckReceptorFileAccessResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.CheckReceptorFileAccessResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.CheckReceptorFileAccessResponse}
 */
proto.receptorutil.CheckReceptorFileAccessResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.receptorutil.ReceptorFileAccess;
      reader.readMessage(value,proto.receptorutil.ReceptorFileAccess.deserializeBinaryFromReader);
      msg.addResults(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceptorIdentity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.CheckReceptorFileAccessResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.CheckReceptorFileAccessResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.CheckReceptorFileAccessResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.CheckReceptorFileAccessResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResultsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.receptorutil.ReceptorFileAccess.serializeBinaryToWriter
    );
  }
  f = message.getReceptorIdentity();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated ReceptorFileAccess results = 1;
 * @return {!Array<!proto.receptorutil.ReceptorFileAccess>}
 */
proto.receptorutil.CheckReceptorFileAccessResponse.prototype.getResultsList = function() {
  return /** @type{!Array<!proto.receptorutil.ReceptorFileAccess>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.receptorutil.ReceptorFileAccess, 1));
};


/**
 * @param {!Array<!proto.receptorutil.ReceptorFileAccess>} value
 * @return {!proto.receptorutil.CheckReceptorFileAccessResponse} returns this
*/
proto.receptorutil.CheckReceptorFileAccessResponse.prototype.setResultsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.receptorutil.ReceptorFileAccess=} opt_value
 * @param {number=} opt_index
 * @return {!proto.receptorutil.ReceptorFileAccess}
 */
proto.receptorutil.CheckReceptorFileAccessResponse.prototype.addResults = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.receptorutil.ReceptorFileAccess, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.receptorutil.CheckReceptorFileAccessResponse} returns this
 */
proto.receptorutil.CheckReceptorFileAccessResponse.prototype.clearResultsList = function() {
  return this.setResultsList([]);
};


/**
 * optional string receptor_identity = 2;
 * @return {string}
 */
proto.receptorutil.CheckReceptorFileAccessResponse.prototype.getReceptorIdentity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.CheckReceptorFileAccessResponse} returns this
 */
proto.receptorutil.CheckReceptorFileAccessResponse.prototype.setReceptorIdentity = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetGoogleDrivePickerConfigRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetGoogleDrivePickerConfigRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetGoogleDrivePickerConfigRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetGoogleDrivePickerConfigRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetGoogleDrivePickerConfigRequest}
 */
proto.receptorutil.GetGoogleDrivePickerConfigRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetGoogleDrivePickerConfigRequest;
  return proto.receptorutil.GetGoogleDrivePickerConfigRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetGoogleDrivePickerConfigRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetGoogleDrivePickerConfigRequest}
 */
proto.receptorutil.GetGoogleDrivePickerConfigRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetGoogleDrivePickerConfigRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetGoogleDrivePickerConfigRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetGoogleDrivePickerConfigRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetGoogleDrivePickerConfigRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.receptorutil.GetGoogleDrivePickerConfigResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.receptorutil.GetGoogleDrivePickerConfigResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.receptorutil.GetGoogleDrivePickerConfigResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetGoogleDrivePickerConfigResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    oauthClientId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    appId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.receptorutil.GetGoogleDrivePickerConfigResponse}
 */
proto.receptorutil.GetGoogleDrivePickerConfigResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.receptorutil.GetGoogleDrivePickerConfigResponse;
  return proto.receptorutil.GetGoogleDrivePickerConfigResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.receptorutil.GetGoogleDrivePickerConfigResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.receptorutil.GetGoogleDrivePickerConfigResponse}
 */
proto.receptorutil.GetGoogleDrivePickerConfigResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOauthClientId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAppId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.receptorutil.GetGoogleDrivePickerConfigResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.receptorutil.GetGoogleDrivePickerConfigResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.receptorutil.GetGoogleDrivePickerConfigResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.receptorutil.GetGoogleDrivePickerConfigResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOauthClientId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAppId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string oauth_client_id = 1;
 * @return {string}
 */
proto.receptorutil.GetGoogleDrivePickerConfigResponse.prototype.getOauthClientId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetGoogleDrivePickerConfigResponse} returns this
 */
proto.receptorutil.GetGoogleDrivePickerConfigResponse.prototype.setOauthClientId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string app_id = 2;
 * @return {string}
 */
proto.receptorutil.GetGoogleDrivePickerConfigResponse.prototype.getAppId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.receptorutil.GetGoogleDrivePickerConfigResponse} returns this
 */
proto.receptorutil.GetGoogleDrivePickerConfigResponse.prototype.setAppId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.receptorutil.MetadataType = {
  METADATA_TYPE_UNSPECIFIED: 0,
  METADATA_TYPE_DIRECTORY: 1,
  METADATA_TYPE_LABEL: 2
};

goog.object.extend(exports, proto.receptorutil);
